import type { BetterDocSpecialty } from "@/modules/patients/detail/better-doc/lib/better-doc-sub-specialties"
import type { de_BetterDocSubSpeciality } from "@/types/__generated__/union-types"

const DE_BETTER_DOC_SUB_SPECIALTIES: Partial<Record<BetterDocSpecialty, readonly de_BetterDocSubSpeciality[]>> = {
  GENERAL_INTERNAL_MEDICINE: ["GERIATRICS"],
  SURGERY: ["GENERAL_SURGERY_TRAUMATOLOGY", "VISCERAL_SURGERY", "SURGICAL_SENOLOGY"],
  DERMATOLOGY_AND_VENEREOLOGY: ["DERMATOPATHOLOGY"],
  GASTROENTEROLOGY: ["HEPATOLOGY"],
  GYNECOLOGY_AND_OBSTETRICS: [
    "OPERATIVE_GYNECOLOGY_AND_OBSTETRICS",
    "GYNECOLOGIC_ONCOLOGY",
    "FETOMATERNAL_MEDICINE",
    "REPRODUCTIVE_MEDICINE_AND_GYNECOLOGICAL_ENDOCRINOLOGY",
    "UROGYNECOLOGY",
    "GYNECOLOGICAL_SENOLOGY",
  ],
  INFECTIOLOGY: ["INFECTION_PREVENTION_AND_CONTROL"],
  PEDIATRICS_AND_ADOLESCENT_MEDICINE: [
    "PEDIATRIC_ENDOCRINOLOGY_DIABETOLOGY",
    "PEDIATRIC_GASTROENTEROLOGY_AND_HEPATOLOGY",
    "PEDIATRIC_CARDIOLOGY",
    "NEONATOLOGY",
    "PEDIATRIC_NEPHROLOGY",
    "NEUROPAEDIATRICS",
    "PEDIATRIC_ONCOLOGY_HEMATOLOGY",
    "PEDIATRIC_PNEUMOLOGY",
    "PEDIATRIC_RHEUMATOLOGY",
    "DEVELOPMENTAL_PEDIATRICS",
    "PEDIATRIC_EMERGENCY_MEDICINE",
  ],
  PEDIATRIC_SURGERY: ["PEDIATRIC_SURGERY_EMERGENCY_MEDICINE"],
  OPHTHALMOLOGY: ["OPHTHALMOLOGY"],
  OTO_RHINO_LARYNGOLOGY: ["EAR_NOSE_THROAT_PHONIATRICS"],
  PATHOLOGY: ["CYTOPATHOLOGY_PATHOLOGY", "MOLECULAR_PATHOLOGY"],
  RADIOLOGY: ["PEDIATRIC_RADIOLOGY", "DIAGNOSTIC_NEURORADIOLOGY", "INVASIVE_NEURORADIOLOGY"],
  UROLOGY: ["OPERATIVE_UROLOGY", "NEUROUROLOGY", "UROLOGY_FOR_WOMEN"],
}

export const getDeBetterDocSubSpecialties = (
  specialtyName: BetterDocSpecialty | undefined,
): readonly de_BetterDocSubSpeciality[] =>
  specialtyName === undefined ? [] : (DE_BETTER_DOC_SUB_SPECIALTIES[specialtyName] ?? [])
